import { AutoComplete as AntdAutoComplete, AutoCompleteProps, Tooltip } from 'antd';
import React, { useState } from 'react';

import { IMappedStatusRowData } from '@components/common/AutoCompleteInput/buildOptionsWithTag';
import { buildOptionsWithHighlightAndTag } from '@src/emp-3.0/utils/buildOptions';

import styles from './index.less';

export interface IAutoComplete extends AutoCompleteProps {
  mappedData?: IMappedStatusRowData[];
  blockedData?: string[];
}

const AutoComplete: React.FC<IAutoComplete> = ({
  mappedData,
  blockedData,
  options,
  onSearch,
  onChange,
  value,
  ...rest
}) => {
  const [searchText, setSearchText] = useState<string>('');

  const selectOptions = buildOptionsWithHighlightAndTag(
    options,
    searchText,
    mappedData,
    blockedData,
  );

  return (
    <Tooltip title={value || 'No value selected'} placement="top">
      <AntdAutoComplete
        allowClear
        options={selectOptions}
        dropdownMatchSelectWidth={350}
        popupClassName={styles.enhancementAntSelectDropdown}
        // getPopupContainer={(triggerNode) => triggerNode.parentNode.parentNode}
        value={value}
        onSearch={(text) => {
          setSearchText(text);
          onSearch?.(text);
        }}
        onChange={(value, options) => {
          setSearchText(value);
          onChange?.(value, options);
        }}
        {...rest}
      />
    </Tooltip>
  );
};

export default AutoComplete;
